import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Inbox, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/lib/brand";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/enquiries", label: "Enquiries", icon: Inbox },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex" style={{ background: "#F5FAFC" }}>
      <aside className="w-60 shrink-0 hidden md:flex flex-col border-r bg-white" style={{ borderColor: "rgba(8,127,191,0.12)" }}>
        <div className="p-5 border-b" style={{ borderColor: "rgba(8,127,191,0.12)" }}>
          <img src={BRAND.logo} alt="BIOSYN" className="h-9" />
          <p className="mt-2 text-[10px] font-semibold uppercase tracking-widest" style={{ color: "#087FBF" }}>Admin</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-semibold transition-colors ${isActive ? "text-white" : ""}`}
              style={({ isActive }) => (isActive ? { background: "#087FBF" } : { color: "#17324D" })}>
              <l.icon className="w-4.5 h-4.5" style={{ width: 18, height: 18 }} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t space-y-1" style={{ borderColor: "rgba(8,127,191,0.12)" }}>
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-semibold" style={{ color: "#17324D" }}>
            <ExternalLink style={{ width: 18, height: 18 }} /> View Site
          </a>
          <button onClick={() => { logout(); nav("/admin/login"); }} data-testid="admin-logout" className="flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-semibold w-full text-left" style={{ color: "#c0392b" }}>
            <LogOut style={{ width: 18, height: 18 }} /> Logout
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="md:hidden flex items-center justify-between p-4 bg-white border-b" style={{ borderColor: "rgba(8,127,191,0.12)" }}>
          <img src={BRAND.logo} alt="BIOSYN" className="h-8" />
          <button onClick={() => { logout(); nav("/admin/login"); }} className="text-sm font-semibold" style={{ color: "#c0392b" }}>Logout</button>
        </header>
        <div className="md:hidden flex gap-1 p-2 bg-white border-b overflow-x-auto" style={{ borderColor: "rgba(8,127,191,0.12)" }}>
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap ${isActive ? "text-white" : ""}`} style={({ isActive }) => (isActive ? { background: "#087FBF" } : { color: "#17324D", background: "#F5FAFC" })}>
              {l.label}
            </NavLink>
          ))}
        </div>
        <main className="flex-1 p-5 md:p-8 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
